<mat-drawer-container hasBackdrop="true"
                      class="h-100">

    <mat-drawer #drawer
                mode="over">

        @defer() {
        @if(vendorIsLoaded) {
        <lib-sidebar-content [title]="applicationTitle"
                             [navigationOptions]="navigationOptions"
                             (toggleDrawer)="drawer.toggle()"
                             (closeDrawer)="drawer.close()"></lib-sidebar-content>
        }
        }

    </mat-drawer>

    <mat-drawer-content>
        <router-outlet>

            @defer () {
            <!-- Should only be visible after successful login & vendor load. -->
            @if(vendorIsLoaded) {
            <lib-header (toggleDrawer)="drawer.toggle()"
                        [navigationOptions]="navigationOptions"
                        [title]="applicationTitle"></lib-header>
            }
            }

        </router-outlet>
    </mat-drawer-content>
</mat-drawer-container>